interface ToggleProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label: string;
}

export function Toggle({ checked, onChange, label }: ToggleProps) {
    return (
        <button type="button" role="switch" aria-checked={checked} className="toggle-row" onClick={() => onChange(!checked)}>
            <span className="toggle-track" aria-hidden="true"
                style={{ background: checked ? 'var(--lm-aquamarine)' : 'var(--lm-gray-2)' }}>
                <span className="toggle-thumb" style={{ transform: checked ? 'translateX(16px)' : 'translateX(0)' }} />
            </span>
            <span>{label}</span>
        </button>
    );
}
